import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Button, Stack } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { Delete01Icon, Cancel01Icon } from "@hugeicons/core-free-icons";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({
  isOpen,
  onToggle,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmVariant = "danger",
  confirmIcon = Delete01Icon,
  cancelIcon = Cancel01Icon,
  isLoading = false,
  loadingText,
  dangerText,
  size = "md",
  centered = true,
}) => {
  const { t } = useTranslation();

  // Default texts
  const defaultTitle = title || t("CONFIRM");
  const defaultConfirmText = confirmText || t("DELETE");
  const defaultCancelText = cancelText || t("CANCEL");
  const defaultLoadingText = loadingText || "جاري التحميل...";

  return (
    <Modal isOpen={isOpen} toggle={onToggle} centered={centered} size={size}>
      <ModalHeader toggle={onToggle}>
        <span className="h4">{defaultTitle}</span>
      </ModalHeader>
      <ModalBody>
        <div className="confirm-modal-content">
          {message && (
            <p className="h4 mb-4">
              {typeof message === "string" ? (
                dangerText ? (
                  <>
                    {message.split(dangerText)[0]}
                    <span className="text-danger">{dangerText}</span>
                    {message.split(dangerText)[1]}
                  </>
                ) : (
                  message
                )
              ) : (
                message
              )}
            </p>
          )}

          <Stack direction="horizontal" gap={2}>
            <Button
              variant={confirmVariant}
              onClick={onConfirm}
              disabled={isLoading}
              className={`outline btn-icon btn-xs btn-${confirmVariant}`}
            >
              <HugeiconsIcon size={14} icon={confirmIcon} />
              {isLoading ? defaultLoadingText : defaultConfirmText}
            </Button>

            <Button
              onClick={onToggle}
              disabled={isLoading}
              className="btn-danger btn-xs"
            >
              <HugeiconsIcon size={14} icon={cancelIcon} />
              {defaultCancelText}
            </Button>
          </Stack>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmModal;
